import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./GridShowcase.css";
import Loading from "../loading/Loading";

const GridShowcase = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleRedirect = (packageFilter) => {
    setIsLoading(true);
    setTimeout(() => {
      navigate(`/tours?package=${packageFilter}`);
      window.scrollTo(0, 0);
    }, 1000);
  };

  const IMG_URL = "https://twintravelcoron.com";

  return (
    <>
      {isLoading && <Loading />}
      <section className="grid-showcase container">
        <div className="item img1" onClick={() => handleRedirect("3D2N")}>
          <img
            src={IMG_URL + "/hotels/Zuri/image.jpg"}
            alt="3 Days 2 Nights Tour Package"
          />
          <div className="hover-content">
            <h3>3D2N</h3>
            <p>
              Experience a quick yet fulfilling getaway with our 3 Days and 2
              Nights package, perfect for short vacations.
            </p>
            <span>Price starts at: ₱4,200 </span>
          </div>
        </div>
        <div className="item text1">
          <h2>Tour Packages</h2>
          <p>
            Discover the best travel experiences with our carefully curated tour
            packages. From short weekend trips to extended vacations, find the
            perfect package that suits your needs and budget.
          </p>
        </div>
        <div className="item img2" onClick={() => handleRedirect("4D3N")}>
          <img
            src="https://img.freepik.com/free-photo/beautiful-beach-view-koh-chang-island-seascape-trad-province-eastern-thailand-blue-sky-background_1150-10256.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid
"
            alt="4 Days 3 Nights Vacation Package"
          />
          <div className="hover-content">
            <h3>4D3N</h3>
            <p>
              Unwind and explore at your own pace with our 4 Days and 3 Nights
              package, ideal for a mid-length vacation.
            </p>
            <span>Price starts at: ₱5,900 </span>
          </div>
        </div>
        <div className="item img3" onClick={() => handleRedirect("5D4N")}>
          <img
            src={IMG_URL + "/hotels/WestownHotel/image.jpg"}
            alt="5 Days 4 Nights Holiday Package"
          />
          <div className="hover-content">
            <h3>5D4N</h3>
            <p>
              Immerse yourself in a complete travel experience with our 5 Days
              and 4 Nights package, giving you ample time to explore.
            </p>
            <span>Price starts at: ₱7,500 </span>
          </div>
        </div>
        <div className="item img4" onClick={() => handleRedirect("7D6N")}>
          <img
            src={IMG_URL + "/hotels/ViennaHotel/image2.jpg"}
            alt="7 Days 6 Nights Extended Vacation Package"
          />
          <div className="hover-content">
            <h3>7D6N</h3>
            <p>
              Enjoy a week-long adventure with our 7 Days and 6 Nights package,
              perfect for those seeking a more extensive getaway.
            </p>
            <span>Price starts at: ₱13,000 </span>
          </div>
        </div>
      </section>
    </>
  );
};

export default GridShowcase;
